import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { CaretDownOutlined } from '@ant-design/icons';
import { AutoComplete, Input, Tooltip, } from 'antd';
import { fetchInputHistory } from 'api/user-api';
import { useSession } from 'components/Authenticated';
import IconButton from 'components/IconButton';
import { txt } from 'libs/i18n';
import styles from './style.module.less';
const { Search } = Input;
const LAST_SEARCH_INPUT_AMOUNT = 5;
const InputWithHistory = ({ value, onChange, inputId, isSearchInput, onSearch, onPopoverVisible, }) => {
    const [searchHistory, setSearchHistory] = useState([]);
    const { session } = useSession();
    const getInputHistory = async (input) => {
        const history = await fetchInputHistory(session.connection, input, 0, LAST_SEARCH_INPUT_AMOUNT);
        setSearchHistory(history.map((query) => ({ label: query, value: query })));
    };
    const suffix = (_jsx(IconButton, { onClick: onPopoverVisible, children: _jsx(Tooltip, { title: txt('advancedSearch'), children: _jsx(CaretDownOutlined, { className: styles.icon }) }) }));
    return (_jsx(AutoComplete, { bordered: false, value: value, onChange: onChange, options: searchHistory, onFocus: () => getInputHistory(inputId), onBlur: () => setSearchHistory([]), onSelect: () => setSearchHistory([]), open: searchHistory.length > 0, children: isSearchInput && (_jsx(Search, { value: value, placeholder: txt('fulltextSearch'), className: styles.searchInput, onSearch: onSearch, enterButton: true, suffix: suffix, name: "search" })) }));
};
export default InputWithHistory;
